import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	overflow: hidden;

	display: none;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 0 0 2em 0;
	background-color: ${vars.colorBackgroundContrastDark};
	padding: 1em;

	&.notEmpty {
		display: flex;
	}

	.index-title {
		font-weight: 600;
		font-size: 0.9em;
		margin: 0 0 0.5em 0;
	}

	.index-text {
		font-size: 0.8em;
		text-decoration: none;
		display: inline-block;
		width: 100%;
		align-items: center;
		color: #3175e4;
		margin-bottom: 6px;
		font-weight: 300;
		&:last-of-type {
			margin-bottom: 0;
		}
		a {
			font-size: 0.8em;
		}
		span {
			margin-right: 6px;
		}
		&:hover {
			cursor: pointer;
		}
	}

	.index-level {
		display: inline-block;
		margin-bottom: 0;
		margin-top: 0;
		margin-left: 1em;
	}

	&.white {
		background-color: ${vars.colorBackgroundContrast};
	}
`;
